import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DialogOverlay"], _mergeProps($setup.delegatedProps, {
        class: $setup.cn('bg-en-blue-500/35 fixed inset-0 z-1010', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $setup.props.class)
    }), null, 16 /* FULL_PROPS */, ["class"]));
}
